/** @jsx jsx */
import { Fragment } from 'react'
import { GatsbyImage, getImage, withArtDirection } from 'gatsby-plugin-image'
import { Box, Button, Container, Flex, Grid, Heading, jsx } from 'theme-ui'

const GroupGiftingHeroSection = ({ cta, description, images, title }) => {
  return (
    <Box bg="backgroundLight" sx={{ overflow: 'hidden', position: 'relative' }}>
      {images && (
        <Fragment>
          <Box
            sx={{
              bottom: [null, '0'],
              height: ['204px', '328px', '355px', '431px'],
              left: ['50%', '0'],
              overflow: 'hidden',
              pointerEvents: 'none',
              position: ['relative', 'absolute'],
              top: ['0', 'auto'],
              transform: ['translateX(-50%)', 'none'],
              width: ['398px', '162px', '211px', '276px'],
              '@media only screen and (min-width: 1440px)': {
                height: '564px',
                width: '500px',
              },
            }}
          >
            <GatsbyImage
              image={withArtDirection(getImage(images[0]), [
                {
                  image: getImage(images[7]),
                  media: `(min-width: 1440px)`,
                },
                {
                  image: getImage(images[5]),
                  media: `(min-width: 1024px)`,
                },
                {
                  image: getImage(images[3]),
                  media: `(min-width: 832px)`,
                },
                {
                  image: getImage(images[1]),
                  media: `(min-width: 640px)`,
                },
                {
                  image: getImage(images[0]),
                  media: `(min-width: 0px)`,
                },
              ])}
              alt={images[0].description}
              loading={'eager'}
              style={{ height: '100%', width: 'auto' }}
            />
          </Box>
          <Box
            sx={{
              bottom: [null, '0'],
              display: ['none', 'block'],
              height: ['204px', '310px', '330px', '407px'],
              left: ['50%', 'auto'],
              overflow: 'hidden',
              pointerEvents: 'none',
              position: ['relative', 'absolute'],
              right: [null, '0', '-20px', '0'],
              top: ['0', 'auto'],
              transform: ['translateX(-50%)', 'none'],
              width: ['398px', '147px', '206px', '249px'],
              '@media only screen and (min-width: 1440px)': {
                height: '564px',
                width: '410px',
              },
            }}
          >
            <GatsbyImage
              image={withArtDirection(getImage(images[0]), [
                {
                  image: getImage(images[8]),
                  media: `(min-width: 1440px)`,
                },
                {
                  image: getImage(images[6]),
                  media: `(min-width: 1024px)`,
                },
                {
                  image: getImage(images[4]),
                  media: `(min-width: 832px)`,
                },
                {
                  image: getImage(images[2]),
                  media: `(min-width: 640px)`,
                },
                {
                  image: getImage(images[0]),
                  media: `(min-width: 0px)`,
                },
              ])}
              alt={images[0].description}
              loading={'eager'}
              style={{ height: '100%', width: 'auto' }}
            />
          </Box>
        </Fragment>
      )}
      <Container pt={[3, 9, 10, '128px']} pb={[6, '136px', '120px', '132px']}>
        <Grid columns={[1, 12]} sx={{ rowGap: '0', textAlign: 'center' }}>
          <Box sx={{ gridColumn: ['1 / -1'] }}>
            <Heading as="h1" mb={[2, 3]} variant="title1">
              {title}
            </Heading>
          </Box>
          <Box sx={{ gridColumn: [null, '3 / 11', null, '4 / 10'] }}>
            <Box
              mb={4}
              variant="text.body1"
              sx={{ p: { m: 0 } }}
              dangerouslySetInnerHTML={{
                __html: description.childMarkdownRemark.html,
              }}
            />
            <Flex
              sx={{
                flexDirection: ['column', null, 'row'],
                justifyContent: 'center',
                a: { width: ['100%', 'auto'] },
              }}
            >
              <Box mb={[2, null, 0]} mr={[0, null, 2]}>
                {cta}
              </Box>
              <Box>
                <Button
                  as="a"
                  href="mailto:hq@makerwine.com"
                  variant="secondary"
                  bg="white"
                >
                  {'Contact us'}
                </Button>
              </Box>
            </Flex>
          </Box>
        </Grid>
      </Container>
    </Box>
  )
}

export default GroupGiftingHeroSection
